import { type IColumnTypes } from "commonComponents/utilities/AgGridReact/AgGridReact.types";
import { columnCheckbox } from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnCheckbox";
import { columnCurrency } from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnCurrency";
import {
    columnDate,
    columnDateEdit,
} from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnDate";
import { columnDateTime } from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnDateTime";
import { columnDiscussion } from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnDiscussion";
import { columnFiles } from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnFiles";
import {
    columnNumber,
    columnNumberEdit,
} from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnNumber";
import { columnPercentage } from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnPercentage";
import { columnRfi } from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnRFI";
import {
    columnText,
    columnTextEdit,
} from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnText";
import { columnUrl } from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnUrl";
import { columnUser } from "commonComponents/utilities/AgGridReact/standardColumnImplementations/columnUser";
import {
    checkboxValueFormatter,
    currencyValueFormatter,
    dateTimeValueFormatter,
    dateValueFormatter,
    numberValueFormatter,
    percentageValueFormatter,
    userValueFormatter,
} from "commonComponents/utilities/AgGridReact/standardValueFormatters/standardValueFormatters";

export const standardColumnImplementations: IColumnTypes = {
    checkbox: {
        cellRenderer: columnCheckbox,
        cellEditor: columnCheckbox,
        valueFormatter: checkboxValueFormatter,
    },
    user: {
        cellRenderer: columnUser,
        valueFormatter: userValueFormatter,
    },
    currency: {
        cellRenderer: columnCurrency,
        valueFormatter: currencyValueFormatter,
    },
    date: {
        cellRenderer: columnDate,
        cellEditor: columnDateEdit,
        valueFormatter: dateValueFormatter,
    },
    dateTime: {
        cellRenderer: columnDateTime,
        valueFormatter: dateTimeValueFormatter,
    },
    discussion: {
        cellRenderer: columnDiscussion,
        valueFormatter: (params) => params.value?.commentCount.toString() ?? "0",
    },
    files: {
        cellRenderer: columnFiles,
        valueFormatter: (params) => params.value?.docCount.toString() ?? "0",
    },
    number: {
        cellRenderer: columnNumber,
        cellEditor: columnNumberEdit,
        valueFormatter: numberValueFormatter,
    },
    percentage: {
        cellRenderer: columnPercentage,
        valueFormatter: percentageValueFormatter,
    },
    rfi: {
        cellRenderer: columnRfi,
        valueFormatter: (params) => params.value?.rfiCount.toString() ?? "0",
    },
    text: {
        cellRenderer: columnText,
        cellEditor: columnTextEdit,
    },
    url: {
        cellRenderer: columnUrl,
    },
};
